"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SelectMode;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _SelectModeModule = _interopRequireDefault(require("./SelectMode.module.scss"));

var _LobbySeatBadge = _interopRequireDefault(require("./components/LobbySeatBadge/LobbySeatBadge"));

var _character = _interopRequireDefault(require("../../../../../mocks/character"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SelectMode(_ref) {
  var onSelectExistingCharacter = _ref.onSelectExistingCharacter,
      onCreateNewCharacter = _ref.onCreateNewCharacter;
  // TODO
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var selectCharacter = (0, _react.useCallback)(function () {// setViewMode(EViewMode.SELECTED_CHARACTER);

    /*
        // TODO
        $('#input_seat_select').val(seat);
        // copy selected seat to selected seat
        $clone = $('#seat_'+seat).clone(false);
        $clone.css('float','none');
        $clone.css('margin','0px auto');
        // remove onlcikc attribute from clone
        $clone.find('.selectcharbase').find('a').removeAttr('onclick');
        $clone.find('.selectcharfigure').find('a').removeAttr('onclick');
        $("#seat_selected").append($clone);
        // Toggle view
        $('#view_seats').fadeOut('slow', function() {
            $('#view_selected').fadeIn('slow');
        });
        */
  }, []);
  var onClickSeat = (0, _react.useCallback)(function (seatIndex, characterId) {
    if (characterId) {
      if (onSelectExistingCharacter) onSelectExistingCharacter(characterId);
    } else if (onCreateNewCharacter) onCreateNewCharacter(seatIndex);
  }, [onSelectExistingCharacter, onCreateNewCharacter]);
  var renderSeats = (0, _react.useCallback)(function () {
    var nodes = [];
    var character;

    var _loop = function _loop(_seatIndex) {
      if (_seatIndex === 2) character = _character.default;
      if (_seatIndex === 3) character = _objectSpread(_objectSpread({}, _character.default), {}, {
        isHardcore: true
      });
      if (_seatIndex === 4) character = _character.default;
      nodes.push( /*#__PURE__*/_react.default.createElement(_LobbySeatBadge.default, {
        character: character,
        isGamemaster: _seatIndex === 4,
        className: (0, _classnames.default)(_SelectModeModule.default.seat, _SelectModeModule.default["seat".concat(_seatIndex + 1)]),
        onClick: function onClick(characterId) {
          return onClickSeat(_seatIndex, characterId);
        }
      }));
      character = undefined;
    };

    for (var _seatIndex = 0; _seatIndex <= 4; _seatIndex += 1) {
      _loop(_seatIndex);
    }

    return nodes;
  }, [onClickSeat]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _SelectModeModule.default.selectMode
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SelectModeModule.default.seats
  }, renderSeats()));
}